import { WSQueryConfig } from "@ws-react-query";
import { TaxEstimate } from "@wingspanhq/wingspan-api-sdk";
import { taxEstimatesApi } from "@api";
import { useWSQuery } from "../../../../query/helpers";
import { WSServiceError } from "../../../../utils/serviceHelper";

export const QUERY_V3_TAX_ESTIMATE = "QUERY_V3_TAX_ESTIMATE";

export const useTaxEstimateQuery = (
  year: number,
  config?: WSQueryConfig<TaxEstimate, WSServiceError>
) =>
  useWSQuery<TaxEstimate, WSServiceError>(
    [QUERY_V3_TAX_ESTIMATE, year],
    () => taxEstimatesApi.createTaxEstimate({ taxEstimateRequest: { year } }),
    { retry: false, ...config }
  );
